/**
 * Vivi PDP desktop gallery � Maria B�style vertical mousewheel slider.
 * Desktop (?990px): vertical slides + wheel navigation + thumb sync.
 * Mobile/tablet: untouched Dawn horizontal gallery.
 *
 * Wheel over the gallery is trapped (page does not scroll) � same as Maria B.
 * One intentional gesture = one slide (accumulated delta + cooldown) so
 * trackpad inertia cannot race through the whole stack.
 */
(function () {
  const MQ = '(min-width: 990px)';
  const SPEED_MS = 1000;
  const WHEEL_COOLDOWN_MS = 1100;
  const WHEEL_ACC_THRESHOLD = 48;

  function initAll() {
    document.querySelectorAll('media-gallery.vivi-pdp-gallery, .vivi-pdp media-gallery').forEach((gallery) => {
      if (gallery.dataset.viviGalleryInit === 'true') return;
      gallery.dataset.viviGalleryInit = 'true';
      new ViviPdpGallery(gallery);
    });
  }

  class ViviPdpGallery {
    constructor(gallery) {
      this.gallery = gallery;
      this.viewer = gallery.querySelector('[id^="GalleryViewer"]');
      this.list = gallery.querySelector('.product__media-list');
      this.thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
      this.mql = window.matchMedia(MQ);
      this.index = 0;
      this.locked = false;
      this.syncing = false;
      this.height = 0;
      this.enabled = false;
      this.wheelBound = false;
      this.wheelAcc = 0;
      this.progressFill = null;

      if (!this.viewer || !this.list) return;

      this.onWheel = this.onWheel.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onThumbClick = this.onThumbClick.bind(this);
      this.onMql = this.onMql.bind(this);

      this.ensureProgress();
      this.mql.addEventListener('change', this.onMql);
      window.addEventListener('resize', this.onResize);
      if (this.thumbs) {
        this.thumbs.addEventListener('click', this.onThumbClick);
      }

      this.observer = new MutationObserver(() => {
        if (!this.enabled || this.syncing) return;
        const active = this.slides().findIndex((s) => s.classList.contains('is-active'));
        if (active >= 0 && active !== this.index) this.goTo(active, false);
      });
      this.observer.observe(this.list, { attributes: true, attributeFilter: ['class'], subtree: true });

      this.onMql();
    }

    slides() {
      return Array.from(this.list.querySelectorAll('.product__media-item')).filter((el) => {
        if (el.classList.contains('product__media-item--variant') && el.style.display === 'none') {
          return false;
        }
        return true;
      });
    }

    ensureProgress() {
      let bar = this.viewer.querySelector('.vivi-gallery-progress');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'vivi-gallery-progress';
        bar.setAttribute('aria-hidden', 'true');
        bar.innerHTML = '<span class="vivi-gallery-progress__fill"></span>';
        this.viewer.appendChild(bar);
      }
      this.progressEl = bar;
      this.progressFill = bar.querySelector('.vivi-gallery-progress__fill');
    }

    onMql() {
      if (this.mql.matches) this.enable();
      else this.disable();
    }

    enable() {
      const slides = this.slides();
      if (slides.length < 2) {
        this.disable();
        return;
      }

      this.enabled = true;
      this.gallery.classList.add('vivi-gallery--vertical');
      if (!this.wheelBound) {
        this.viewer.addEventListener('wheel', this.onWheel, { passive: false });
        this.wheelBound = true;
      }
      this.setHeight();
      const active = slides.findIndex((s) => s.classList.contains('is-active'));
      this.goTo(active >= 0 ? active : 0, false);
    }

    disable() {
      this.enabled = false;
      this.gallery.classList.remove('vivi-gallery--vertical');
      if (this.wheelBound) {
        this.viewer.removeEventListener('wheel', this.onWheel);
        this.wheelBound = false;
      }
      this.wheelAcc = 0;
      this.list.style.transform = '';
      this.list.style.transition = '';
      this.list.style.height = '';
      this.viewer.style.height = '';
      this.slides().forEach((slide) => {
        slide.style.height = '';
        slide.style.minHeight = '';
      });
      if (this.progressEl) this.progressEl.hidden = true;
    }

    setHeight() {
      const slides = this.slides();
      const first = slides[0];
      if (!first) return;

      const img = first.querySelector('img');
      const apply = () => {
        if (!this.enabled) return;
        const w = first.clientWidth || this.viewer.clientWidth;
        let h = img && img.clientHeight > 40 ? img.clientHeight : Math.round(w * 1.5);
        if (h < 120) h = Math.round(w * 1.5);
        this.height = h;
        this.viewer.style.height = `${h}px`;
        this.list.style.height = `${h * slides.length}px`;
        slides.forEach((slide) => {
          slide.style.height = `${h}px`;
          slide.style.minHeight = `${h}px`;
        });
        this.applyTransform(false);
      };

      if (img && !img.complete) {
        img.addEventListener('load', apply, { once: true });
      }
      apply();
    }

    onResize() {
      if (!this.enabled) return;
      this.setHeight();
    }

    onWheel(event) {
      if (!this.enabled) return;

      const slides = this.slides();
      if (slides.length < 2) return;

      // Vertical intent only
      if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;

      // Maria B: trap wheel while pointer is over the gallery (page stays put)
      event.preventDefault();
      event.stopPropagation();

      if (this.locked) return;

      this.wheelAcc += event.deltaY;

      // Direction flip resets accumulation (new gesture)
      if (this.wheelAcc !== 0 && event.deltaY !== 0) {
        const accDir = this.wheelAcc > 0 ? 1 : -1;
        const tickDir = event.deltaY > 0 ? 1 : -1;
        if (accDir !== tickDir) this.wheelAcc = event.deltaY;
      }

      if (Math.abs(this.wheelAcc) < WHEEL_ACC_THRESHOLD) return;

      const dir = this.wheelAcc > 0 ? 1 : -1;
      this.wheelAcc = 0;

      const next = this.index + dir;
      if (next < 0 || next >= slides.length) return;

      this.goTo(next, true);
    }

    onThumbClick(event) {
      if (!this.enabled) return;
      const btn = event.target.closest('[data-target]');
      if (!btn) return;
      const mediaId = btn.dataset.target;
      if (!mediaId) return;

      requestAnimationFrame(() => {
        const slides = this.slides();
        const idx = slides.findIndex((s) => s.dataset.mediaId === mediaId);
        if (idx >= 0) this.goTo(idx, true);
      });
    }

    goTo(index, animate) {
      const slides = this.slides();
      if (!slides.length) return;
      const next = Math.max(0, Math.min(index, slides.length - 1));

      if (next === this.index) {
        this.applyTransform(false);
        return;
      }

      this.index = next;
      this.wheelAcc = 0;

      this.syncing = true;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === next);
      });
      this.syncing = false;

      this.applyTransform(animate);
      this.syncThumbs(slides[next]);
      this.updateProgress(slides.length);

      if (animate) {
        this.locked = true;
        window.setTimeout(() => {
          this.locked = false;
        }, WHEEL_COOLDOWN_MS);
      }
    }

    applyTransform(animate) {
      if (!this.height) return;
      this.list.style.transition = animate ? `transform ${SPEED_MS}ms cubic-bezier(0.22, 1, 0.36, 1)` : 'none';
      this.list.style.transform = `translate3d(0, ${-this.index * this.height}px, 0)`;
    }

    syncThumbs(activeSlide) {
      if (!this.thumbs || !activeSlide) return;
      const mediaId = activeSlide.dataset.mediaId;
      const thumb = this.thumbs.querySelector(`[data-target="${mediaId}"]`);
      if (!thumb) return;

      this.thumbs.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
      const button = thumb.querySelector('button') || thumb;
      button.setAttribute('aria-current', 'true');

      if (typeof this.thumbs.isSlideVisible === 'function' && this.thumbs.isSlideVisible(thumb, 10)) return;
      if (this.thumbs.slider) {
        this.thumbs.slider.scrollTo({ left: thumb.offsetLeft, behavior: 'smooth' });
      }
    }

    updateProgress(total) {
      if (!this.progressEl || !this.progressFill) return;
      if (!this.enabled || total < 2) {
        this.progressEl.hidden = true;
        return;
      }
      this.progressEl.hidden = false;
      const pct = ((this.index + 1) / total) * 100;
      this.progressFill.style.transform = `scaleY(${pct / 100})`;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
